import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getGasLog } from 'redux/action/gasLog';
import { warningLogManager, calibrationLogManager, logInit } from 'redux/action/warningLog';

import StatusComponentInfo from './statusComponentInfo/StatusComponentInfo';
import StatusComponentIcon from './statusComponentIcon/StatusComponentIcon';
import StatusComponentBoard from './statusComponentBoard/StatusComponentBoard';
import StatusComponentMap from './statusComponentMap/StatusComponentMap';
import MainSubIcons from './MainSubIcons';

import { moduleScnTitleMap } from 'utils/code';

import 'bootstrap/dist/css/bootstrap.min.css';
import { MainInfoContainer } from './MainInfo.css.js';
import './MainInfo.css';

// 현재 불출/설치된 장치에 대해 각 유형별 데이터 조회
const dataLogDispatcher = (module, dispatch) => {
  //const gasModules = module.filter((x) => x.moduleScn === moduleScnTitleMap['gas'].scn + '');
  const gasModules = module.filter((x) => x.moduleScn === moduleScnTitleMap['gas2'].scn + '' || x.moduleScn === moduleScnTitleMap['gas'].scn + '');
  dispatch(getGasLog(gasModules));
};

/* 
  메인페이지 사이드에 존재하는 log 페이지의 데이터 조회 
  불출/설치 된 장치가 없으면 빈 데이터로 초기화
*/
const sideLogDispatcher = (module, auth, dispatch) => {
  if (module.length > 0) {
    // dispatch(warningLogManager(auth));
    dispatch(calibrationLogManager(auth));
  } else {
    dispatch(logInit());
  }
};

const MainInfo = (props) => {
  const dispatch = useDispatch();
  const [iconSubView, setIconSubView] = useState(false);
  const [alignOption, setAlignOption] = useState('horizon');

  useEffect(() => {
    const module = props.modules.module; // 관리 중인 모든 장비
    dataLogDispatcher(module, dispatch);
    // sideLogDispatcher(module, props.auth, dispatch);

    const timer = window.setInterval(() => {
      dataLogDispatcher(module, dispatch);
      // sideLogDispatcher(module, props.auth, dispatch);
    }, Number(5000));

    return () => {
      window.clearInterval(timer);
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.dispensingModules, props.modules, props.auth]);

  const switchMainDisplay = useCallback(
    (propsMap) => {
      switch (props.displayMenuName) {
        case 'info':
          return <StatusComponentInfo {...propsMap} />;
        case 'icon':
          return <StatusComponentIcon {...propsMap} />;
        case 'board':
          return <StatusComponentBoard {...propsMap} />;
        case 'map':
          return <StatusComponentMap {...propsMap} />;
        default:
          return <StatusComponentBoard {...propsMap} />;
      }
    },
    [props.displayMenuName]
  );

  return (

    <MainInfoContainer displayMenuName={props.displayMenuName} alignOption={alignOption}>
      {switchMainDisplay({
        dataLogDispatcher: dataLogDispatcher,
        iconSubView: iconSubView,
        alignOption: alignOption,
        ...props,
      })}
    </MainInfoContainer>

  );
};

export default MainInfo;
